import * as React from "react";
import {section__title as sectionTitle} from "./section.module.css";

const SectionTitle = ({children: content}) => {
    return <h2 className={sectionTitle}>{content}</h2>;
};

export default SectionTitle;
